import { create } from 'zustand'
import {
  DEFAULT_FILLER_REMOVAL_SETTINGS,
  type FillerPreviewSummary,
  type FillerRangesByItemId,
  type FillerRemovalSettings,
} from '../utils/filler-word-removal-preview'

interface FillerRemovalDialogState {
  isOpen: boolean
  itemIds: string[]
  settings: FillerRemovalSettings
  rangesByItemId: FillerRangesByItemId
  summary: FillerPreviewSummary | null
  isAnalyzing: boolean
  error: string | null
  open: (itemIds: string[]) => void
  close: () => void
  setSettings: (next: Partial<FillerRemovalSettings>) => void
  setAnalyzing: (isAnalyzing: boolean) => void
  setAnalysisResult: (rangesByItemId: FillerRangesByItemId, summary: FillerPreviewSummary) => void
  setError: (error: string | null) => void
  resetAnalysis: () => void
}

export const useFillerRemovalDialogStore = create<FillerRemovalDialogState>((set) => ({
  isOpen: false,
  itemIds: [],
  settings: DEFAULT_FILLER_REMOVAL_SETTINGS,
  rangesByItemId: {},
  summary: null,
  isAnalyzing: false,
  error: null,
  open: (itemIds) =>
    set({
      isOpen: true,
      itemIds,
      rangesByItemId: {},
      summary: null,
      isAnalyzing: false,
      error: null,
    }),
  close: () =>
    set({
      isOpen: false,
      itemIds: [],
      rangesByItemId: {},
      summary: null,
      isAnalyzing: false,
      error: null,
    }),
  setSettings: (next) =>
    set((state) => ({
      settings: {
        ...state.settings,
        ...next,
      },
    })),
  setAnalyzing: (isAnalyzing) => set({ isAnalyzing }),
  setAnalysisResult: (rangesByItemId, summary) =>
    set({
      rangesByItemId,
      summary,
      error: null,
      isAnalyzing: false,
    }),
  setError: (error) => set({ error, isAnalyzing: false }),
  resetAnalysis: () =>
    set({
      rangesByItemId: {},
      summary: null,
      error: null,
      isAnalyzing: false,
    }),
}))